import { Title } from "@mantine/core";

export function HeaderLeft() {
  return <Title>Create New Invoice</Title>;
}
